import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { miscApi } from "@/api";

export default function Changelog() {
  const { pid } = useParams();
  const [logs, setLogs] = useState([]);
  useEffect(() => { miscApi.changelog(pid).then(setLogs).catch(() => {}); }, [pid]);

  return (
    <div className="p-8 max-w-3xl fade-up">
      <p className="overline text-primary mb-1">Journal des modifications</p>
      <h1 className="font-serif text-4xl font-light tracking-tight mb-6">Historique</h1>

      {logs.length === 0 ? (
        <div className="border border-dashed border-border rounded-lg py-16 text-center text-muted-foreground">
          <ClockCounterClockwise size={40} weight="duotone" className="mx-auto mb-3 opacity-50" />
          Aucune modification enregistrée. Vos décisions (acceptations, refus) apparaîtront ici.
        </div>
      ) : (
        <div className="space-y-2">
          {logs.map((l) => (
            <div key={l.id} data-testid={`changelog-${l.id}`} className="flex items-center gap-4 border border-border bg-surface rounded-sm px-4 py-3">
              <span className="text-xs font-mono text-muted-foreground w-32">{new Date(l.timestamp).toLocaleString("fr", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
              <span className="text-sm flex-1">{l.action}</span>
              <span className="text-xs px-2 py-0.5 rounded-sm bg-secondary capitalize">{l.category}</span>
              {l.chapter_index != null && <span className="text-xs text-muted-foreground">Ch. {l.chapter_index + 1}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
